module.exports = __webpack_public_path__ + "img/mobile-logo.002e4f69.png";